import { SQCCRecord, UploadMediaReportItem } from "./upload-media-report-item";

export abstract class UploadMediaReportRepository {
  get: (
    offset: number,
    limit: number,
    searchQuery: string,
    orderBy: "filename" | "date" | "status" | "quality",
    sortBy: "asc" | "desc",
  ) => Promise<{ total: number; items: UploadMediaReportItem[] }>;

  getMediaQCCReports: (mediaId: number) => Promise<SQCCRecord[]>;

  approveMediaQccRecords: (mediaId: number, ids: string[]) => Promise<void>;
}
